/**
 * Configuração de badges de Terceiros (ListaTerceiros).
 * Centraliza lesão, culpado e arcar com custos.
 * Cores espelhadas em $lesao/culpado/custos-badge-cores (_variables.scss) + .*-badge--* (_terceiros.scss).
 */

// ---------------------------------------------------------------------------
// Factory DRY
// ---------------------------------------------------------------------------
function createBadgeGetter(slugMap, prefix) {
  return function getBadgeClass(label) {
    const slug = slugMap[label] || "sem-informacoes";
    return `${prefix} ${prefix}--${slug}`;
  };
}

// ---------------------------------------------------------------------------
// Lesão
// ---------------------------------------------------------------------------
/** @type {Object<string, string>} label → slug da classe CSS */
export const lesaoBadgeSlugMap = {
  "Não": "nao",
  "Sim - Medicalizado": "medicalizado",
  Medicalizado: "medicalizado",
  "Sim - Hospitalizado sem risco de morte": "hospitalizado-sem-risco",
  "Hospitalizado sem risco de morte": "hospitalizado-sem-risco",
  "Sim - Hospitalizado com risco de morte": "hospitalizado-com-risco",
  "Hospitalizado com risco de morte": "hospitalizado-com-risco",
  "Óbito": "obito",
  "Sem informações": "sem-informacoes",
  Sim: "sim",
  "Sem Lesão": "sem-lesao"
};

/**
 * Retorna classe CSS do badge para um label de lesão.
 * @param {string} label - ex: "Não", "Sim - Medicalizado", "Óbito"
 * @returns {string} ex: "lesao-badge lesao-badge--nao"
 */
export const getLesaoBadgeClass = createBadgeGetter(lesaoBadgeSlugMap, "lesao-badge");

// ---------------------------------------------------------------------------
// Culpado
// ---------------------------------------------------------------------------
export const culpadoBadgeSlugMap = {
  Sim: "sim",
  "Não": "nao"
};

/**
 * Badge de culpado possui normalização: apenas "Sim"/"Não" são válidos,
 * demais valores caem em "sem-informacoes" (cinza).
 * @param {string} label
 * @returns {string} ex: "culpado-badge culpado-badge--sim"
 */
export function getCulpadoBadgeClass(label) {
  const normalized = label === "Sim" ? "Sim" : label === "Não" ? "Não" : "sem-informacoes";
  const slug = culpadoBadgeSlugMap[normalized] || "sem-informacoes";
  return `culpado-badge culpado-badge--${slug}`;
}

// ---------------------------------------------------------------------------
// Custos (Arcar com custos)
// ---------------------------------------------------------------------------
/**
 * Valores conforme spec:
 * - "Não pagará" → cinza #F3F4F6
 * - "Pagará as despesas" → verde #DCFCE7
 * - "Acionará o seguro" → azul #DBEAFE
 * - Outro/sem informação → cinza
 */
export const custosBadgeSlugMap = {
  "Não pagará": "nao-pagara",
  "Pagará as despesas": "pagara-despesas",
  "Acionará o seguro": "acionara-seguro"
};

export const getCustosBadgeClass = createBadgeGetter(custosBadgeSlugMap, "custos-badge");
